import React from 'react';
import { Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface CalculatingPriceStateProps {
    /** Optional override for the transitional message. */
    message?: string;
    className?: string;
}

/**
 * Transitional state shown after the geometry analysis completes but before
 * instant prices are available (the async fastlane/brep-explorer analysis is
 * still running). Prevents the manual-quote fallback from flashing while
 * pricing is being calculated.
 */
export const CalculatingPriceState: React.FC<CalculatingPriceStateProps> = ({
    message = 'Calculating prices…',
    className = '',
}) => (
    <div data-testid="calculating-price-state" className={className}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />} />
        <Text type="secondary" style={{ marginLeft: 8 }}>
            {message}
        </Text>
    </div>
);
